/*
 * ============================================================
 * ANTE SEARCH V7.2
 * MUST TANK FAST COLLECTION TEST
 * ============================================================
 *
 * - Must Tank only
 * - Source: MUST DE CARTIER collection
 * - Uses completed Prestige product-card HTML directly
 * - No per-product search requests
 * - Existing results remain if collection retrieval fails
 *
 * ============================================================
 */

(function () {
  "use strict";

  var TARGET_MODEL_ID = "must-tank";
  var COLLECTION_HANDLE = "must-de-cartier";
  var MAX_PAGES = 10;
  var running = false;


  /* =========================================================
     NORMALIZE
     ========================================================= */

  function normalize(value) {
    if (!value) return "";

    return String(value)
      .normalize("NFKC")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[・･\-‐-‒–—―_]/g, "")
      .replace(/[."'’`]/g, "")
      .trim();
  }


  /* =========================================================
     REQUESTED MODEL
     ========================================================= */

  function getRequestedAnalysis() {
    if (
      !window.ANTESearch ||
      typeof window.ANTESearch.analyze !== "function"
    ) {
      return null;
    }

    var params =
      new URLSearchParams(
        window.location.search
      );

    var query =
      params.get("ante_q") ||
      params.get("q") ||
      "";

    if (!query) {
      return null;
    }

    return window.ANTESearch.analyze(query);
  }


  /* =========================================================
     DICTIONARY MODEL MATCH
     ========================================================= */

  function getCandidates(item) {
    var result = [];

    if (
      item &&
      Array.isArray(item.aliases)
    ) {
      result =
        item.aliases.slice();
    }

    if (
      item &&
      item.canonical
    ) {
      result.push(
        item.canonical
      );
    }

    return result;
  }


  function findModel(text) {
    var dictionary =
      window.ANTE_SEARCH_DICTIONARY;

    if (
      !dictionary ||
      !Array.isArray(
        dictionary.models
      )
    ) {
      return null;
    }

    var target =
      normalize(text);

    var best = null;
    var bestLength = 0;

    dictionary.models.forEach(
      function (model) {

        getCandidates(model)
          .forEach(
            function (alias) {

              var candidate =
                normalize(alias);

              if (
                candidate &&
                target.indexOf(
                  candidate
                ) !== -1 &&
                candidate.length >
                  bestLength
              ) {
                best = model;
                bestLength =
                  candidate.length;
              }

            }
          );

      }
    );

    return best;
  }


  function isMustTank(title) {
    var model =
      findModel(title);

    return Boolean(
      model &&
      model.id ===
        TARGET_MODEL_ID
    );
  }


  /* =========================================================
     LOCALE
     ========================================================= */

  function getLocaleRoot() {
    var match =
      window.location.pathname.match(
        /^\/([a-z]{2}(?:-[a-z]{2})?)\//
      );

    if (
      match &&
      match[1]
    ) {
      return "/" +
        match[1] +
        "/";
    }

    return "/";
  }


  /* =========================================================
     COLLECTION URL
     ========================================================= */

  function getCollectionUrl(pageNumber) {
    var url =
      new URL(
        getLocaleRoot() +
        "collections/" +
        COLLECTION_HANDLE,
        window.location.origin
      );

    url.searchParams.set(
      "page",
      String(pageNumber)
    );

    /*
     * Match "Shop by Model":
     * available products only.
     */

    url.searchParams.set(
      "filter.v.availability",
      "1"
    );

    return url.toString();
  }


  /* =========================================================
     FETCH COLLECTION
     ========================================================= */

  async function fetchCollectionPage(
    pageNumber
  ) {
    var response =
      await fetch(
        getCollectionUrl(
          pageNumber
        ),
        {
          credentials:
            "same-origin"
        }
      );

    if (!response.ok) {
      throw new Error(
        "Collection fetch failed: " +
        pageNumber
      );
    }

    var html =
      await response.text();

    return new DOMParser()
      .parseFromString(
        html,
        "text/html"
      );
  }


  /* =========================================================
     READ PRODUCT CARDS
     ========================================================= */

  function readPage(doc) {
    var allCards =
      doc.querySelectorAll(
        'product-list[id^="product-list-"] > product-card.product-card'
      );

    var matches = [];

    allCards.forEach(
      function (card) {

        var titleElement =
          card.querySelector(
            ".ante-product-card-title"
          );

        if (!titleElement) {
          return;
        }

        var title =
          (
            titleElement.textContent ||
            ""
          ).trim();

        if (
          !title ||
          !isMustTank(title)
        ) {
          return;
        }

        var handle =
          (
            card.getAttribute(
              "handle"
            ) || ""
          ).trim();

        if (!handle) {
          return;
        }

        matches.push({
          handle: handle,
          title: title,
          card: card.cloneNode(true)
        });

      }
    );

    return {
      totalCards: allCards.length,
      matches: matches
    };
  }


  /* =========================================================
     UPDATE COUNT
     ========================================================= */

  function updateResultCount(count) {
    var elements =
      document.querySelectorAll(
        ".section-header.justify-self-center.text-center .v-stack > p"
      );

    var params =
      new URLSearchParams(
        window.location.search
      );

    var query =
      params.get("ante_q") ||
      params.get("q") ||
      "";

    var lang =
      (
        document.documentElement.lang ||
        ""
      ).toLowerCase();

    elements.forEach(
      function (element) {

        if (
          lang.indexOf("ja") === 0
        ) {
          element.textContent =
            "「" +
            query +
            "」の検索結果：" +
            count +
            "件表示中";
        }

        else if (
          lang.indexOf("ko") === 0
        ) {
          element.textContent =
            '"' +
            query +
            '" 검색 결과: ' +
            count +
            "개";
        }

        else if (
          lang.indexOf("zh") === 0
        ) {
          element.textContent =
            "“" +
            query +
            "” 搜尋結果：" +
            count +
            "件";
        }

        else {
          element.textContent =
            'Search results for "' +
            query +
            '": ' +
            count +
            " shown";
        }

      }
    );
  }


  /* =========================================================
     HIDE PAGINATION
     ========================================================= */

  function hidePagination() {
    document
      .querySelectorAll(
        ".pagination, pagination-component"
      )
      .forEach(
        function (item) {

          item.style.setProperty(
            "display",
            "none",
            "important"
          );

        }
      );
  }


  /* =========================================================
     RUN
     ========================================================= */

  async function run() {
    if (running) {
      return;
    }

    var analysis =
      getRequestedAnalysis();

    /*
     * V7.2 currently affects
     * Must Tank only.
     */

    if (
      !analysis ||
      !analysis.model ||
      analysis.model.id !==
        TARGET_MODEL_ID
    ) {
      return;
    }


    var list =
      document.querySelector(
        'product-list[id^="product-list-"]'
      );

    if (!list) {
      return;
    }


    running = true;

    document.documentElement
      .setAttribute(
        "data-ante-v7",
        "loading"
      );


    try {

      var products = [];
      var seen =
        new Set();


      /*
       * =======================================================
       * COLLECT COLLECTION PAGES
       * =======================================================
       */

      for (
        var page = 1;
        page <= MAX_PAGES;
        page++
      ) {

        var doc =
          await fetchCollectionPage(
            page
          );

        var pageData =
          readPage(doc);


        /*
         * No product cards:
         * collection pagination ended.
         */

        if (
          pageData.totalCards === 0
        ) {
          break;
        }


        pageData.matches.forEach(
          function (product) {

            if (
              seen.has(
                product.handle
              )
            ) {
              return;
            }

            seen.add(
              product.handle
            );

            products.push(
              product
            );

          }
        );

      }


      /*
       * =======================================================
       * FAIL SAFE
       * =======================================================
       */

      if (
        products.length === 0
      ) {

        document.documentElement
          .setAttribute(
            "data-ante-v7",
            "no-products"
          );

        console.warn(
          "ANTE V7.2: no Must Tank products found. Existing search results preserved."
        );

        return;
      }


      /*
       * =======================================================
       * REPLACE RESULTS
       *
       * IMPORTANT:
       * We already have complete Prestige product-card nodes.
       * No additional Shopify searches are required.
       * =======================================================
       */

      list.innerHTML = "";


      products.forEach(
        function (product) {

          var card =
            product.card;

          card.hidden = false;

          card.style.removeProperty(
            "display"
          );

          card.removeAttribute(
            "data-ante-filtered"
          );

          list.appendChild(
            card
          );

        }
      );


      hidePagination();

      updateResultCount(
        products.length
      );


      document.documentElement
        .setAttribute(
          "data-ante-v7",
          "ready"
        );

      document.documentElement
        .setAttribute(
          "data-ante-v7-count",
          String(
            products.length
          )
        );


      console.info(
        "ANTE V7.2:",
        products.length,
        "Must Tank products rendered directly."
      );

    }

    catch (error) {

      document.documentElement
        .setAttribute(
          "data-ante-v7",
          "error"
        );

      console.error(
        "ANTE V7.2:",
        error
      );

    }

    finally {
      running = false;
    }
  }


  /* =========================================================
     INIT
     ========================================================= */

  if (
    document.readyState ===
      "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      run
    );

  }

  else {
    run();
  }

})();